"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMindsetCustomerSdkRelease = parseMindsetCustomerSdkRelease;
exports.parseMindsetCustomerSdkDownload = parseMindsetCustomerSdkDownload;
exports.parseMindsetCustomerSdkReleaseResponse = parseMindsetCustomerSdkReleaseResponse;
exports.parseMindsetCustomerSdkDownloadResponse = parseMindsetCustomerSdkDownloadResponse;
function exact(input, keys) {
    if (!input || typeof input !== "object" || Array.isArray(input))
        throw new TypeError("Invalid SDK response");
    const value = input;
    if (Object.keys(value).length !== keys.length || keys.some(key => !Object.prototype.hasOwnProperty.call(value, key)))
        throw new TypeError("Invalid SDK fields");
    return value;
}
function matches(value, pattern) {
    if (typeof value !== "string" || !pattern.test(value))
        throw new TypeError("Invalid SDK value");
    return value;
}
const digest = /^[0-9a-f]{64}$/;
const assetKeys = ["assetId", "fileName", "bytes", "sha256"];
const scopeKeys = ["releaseProfile", "supportedPlatforms", "deferredPlatforms"];
function scoped(input, keys) {
    const version = input && typeof input === "object" ? input.schemaVersion : undefined;
    if (version !== 1 && version !== 2)
        throw new TypeError("Invalid SDK version");
    return exact(input, version === 1 ? keys : [...keys, ...scopeKeys]);
}
function tuple(value, expected) {
    return Array.isArray(value) && value.length === expected.length &&
        Object.keys(value).length === expected.length &&
        expected.every((item, index) => Object.prototype.hasOwnProperty.call(value, index) && value[index] === item);
}
function scope(value) {
    if (value.schemaVersion === 1)
        return { schemaVersion: 1 };
    if (value.releaseProfile === "full" && tuple(value.supportedPlatforms, ["web", "android", "ios"]) &&
        tuple(value.deferredPlatforms, [])) {
        return { schemaVersion: 2, releaseProfile: "full", supportedPlatforms: ["web", "android", "ios"], deferredPlatforms: [] };
    }
    if (value.releaseProfile === "web-android" && tuple(value.supportedPlatforms, ["web", "android"]) &&
        tuple(value.deferredPlatforms, ["ios"])) {
        return { schemaVersion: 2, releaseProfile: "web-android", supportedPlatforms: ["web", "android"], deferredPlatforms: ["ios"] };
    }
    throw new TypeError("Invalid SDK scope");
}
function asset(value) {
    if (value.assetId !== "typescript-bundle" || !Number.isSafeInteger(value.bytes) || value.bytes <= 0)
        throw new TypeError("Invalid SDK asset");
    return { assetId: value.assetId, fileName: matches(value.fileName, /^mindset-typescript-clients-\d+\.\d+\.\d+\.zip$/), bytes: value.bytes, sha256: matches(value.sha256, digest) };
}
function parseMindsetCustomerSdkRelease(input) {
    const value = scoped(input, ["schemaVersion", "releaseId", "version", "sourceCommit", "assets"]);
    const releaseScope = scope(value);
    if (!Array.isArray(value.assets) || value.assets.length !== 1)
        throw new TypeError("Invalid SDK release");
    const version = matches(value.version, /^\d+\.\d+\.\d+$/);
    const bundle = asset(exact(value.assets[0], assetKeys));
    if (bundle.fileName !== `mindset-typescript-clients-${version}.zip`)
        throw new TypeError("Invalid SDK filename");
    return { ...releaseScope, releaseId: matches(value.releaseId, digest), version, sourceCommit: matches(value.sourceCommit, /^[0-9a-f]{40}$/), assets: [bundle] };
}
function parseMindsetCustomerSdkDownload(input, expected, now = Date.now()) {
    const hasHeaders = !!input && typeof input === "object" && Object.prototype.hasOwnProperty.call(input, "requiredHeaders");
    const value = scoped(input, ["schemaVersion", "releaseId", ...assetKeys, "url", "expiresAt", ...(hasHeaders ? ["requiredHeaders"] : [])]);
    const releaseScope = scope(value);
    if (matches(value.releaseId, digest) !== expected.releaseId || value.assetId !== expected.assetId)
        throw new TypeError("Out-of-scope SDK download");
    const bundle = asset(value);
    const raw = matches(value.url, /^https:\/\//);
    if (raw.length > 16384 || /[\s\u0000-\u001f\u007f\\]/.test(raw) || raw.includes("#"))
        throw new TypeError("Invalid SDK URL");
    const url = new URL(raw), host = url.hostname.toLowerCase().replace(/\.$/, "");
    if (url.protocol !== "https:" || url.username || url.password || (url.port && url.port !== "443") || !host.includes(".") || /^[\d.]+$/.test(host) || host.includes(":") || /(?:^|\.)(?:localhost|local|internal)$/.test(host))
        throw new TypeError("Invalid SDK URL");
    let requiredHeaders;
    const signedHeaders = url.searchParams.getAll("X-Amz-SignedHeaders");
    if (hasHeaders) {
        const headers = exact(value.requiredHeaders, ["If-Match"]);
        requiredHeaders = { "If-Match": matches(headers["If-Match"], /^"[A-Za-z0-9_-]{1,128}"$/) };
        if (signedHeaders.length !== 1 || signedHeaders[0] !== "host;if-match")
            throw new TypeError("Invalid SDK signed headers");
    }
    else if (signedHeaders.some(headers => headers.toLowerCase().split(";").includes("if-match"))) {
        throw new TypeError("Missing SDK signed headers");
    }
    const expiresAt = matches(value.expiresAt, /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/);
    const deadline = Date.parse(expiresAt);
    if (!Number.isFinite(now) || !Number.isFinite(deadline) || new Date(deadline).toISOString() !== expiresAt || deadline <= now)
        throw new TypeError("Expired SDK download");
    return { ...releaseScope, releaseId: value.releaseId, ...bundle, url: raw, expiresAt, ...(requiredHeaders ? { requiredHeaders } : {}) };
}
function parseMindsetCustomerSdkReleaseResponse(input) {
    return parseMindsetCustomerSdkRelease(exact(input, ["release"]).release);
}
function parseMindsetCustomerSdkDownloadResponse(input, expected, now = Date.now()) {
    return parseMindsetCustomerSdkDownload(exact(input, ["download"]).download, expected, now);
}
//# sourceMappingURL=customer-sdk-release.js.map